package com.vizio.redwolf.utils.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class VersionResponse (
    @SerialName("name") val name: String,
    @SerialName("version") val version: String
)

@Serializable
@JsExport
data class RedwolfVersionResponse (
    @SerialName("service") val service: String,
    @SerialName("version") val version: String
    )